import { useFormDataQuery } from '@/api/getters';
import { summaryStages } from '@/api/types';
import ClientCard from '@/components/ui/ClientCard';
import { CONSULTANTS } from '@/features/v2/consultants';

import dayjs from 'dayjs';

const ClientCardVehicleDamage = ({ className }: { className?: string }) => {
  const { data } = useFormDataQuery();

  if (!data) return null;

  return (
    <ClientCard
      leadID={data.id}
      opportunityID={data.offer.opportunity_id}
      purchaseID={data.offer.purchase_id}
      crmUser={
        data.crm_user?.name
          ? {
              name: data.crm_user.name,
              avatar: data.crm_user.avatar,
            }
          : undefined
      }
      userData={{
        ...data.user,
        carYear: dayjs(data.product.additional_info.car_year).year().toString(),
        car: data.product.additional_info.car ?? '',
        phoneNumber: data.user.phone,
      }}
      guardian={CONSULTANTS.EWELINA_ASSISTANT}
      surcharge={
        summaryStages.includes(data.stage)
          ? data?.offer.surcharge_summary
          : undefined
      }
      isSummaryForm={summaryStages.includes(data.stage)}
      className={className}
    />
  );
};

export default ClientCardVehicleDamage;
